var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"infos"},[_c('div',{staticClass:"city"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":_vm.cityLogo,"alt":"Logo de la ville"}})]),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.cityName))])]),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e485fee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CityInfosMessage.vue
// module id = null
// module chunks = 